import React, { forwardRef } from 'react'
import classNames from 'classnames'
import { Button } from 'antd'

import { BUTTON_TYPE } from '@app/constants/button'

import { getStylesClassName } from '@app/utils/styles'

import styles from './styles.module.scss'

import type { LntButtonProps } from './types'

const block = 'button'

const Component: React.ForwardRefRenderFunction<HTMLElement, LntButtonProps> = (props, ref) => {
  const {
    className: outerClassName,
    type = BUTTON_TYPE.primary,
    children,
    textColor,
    loading,
    style,
    ...restProps
  } = props

  const typeClassName: string | undefined = getStylesClassName(styles, { block, element: type })

  const className: string = classNames(
    styles.button,
    { [styles.button_loading]: loading },
    typeClassName,
    outerClassName
  )

  return (
    <Button
      { ...restProps }
      className={ className }
      loading={ loading }
      style={ { color: textColor, ...style } }
      ref={ ref }
    >
      { children }
    </Button>
  )
}

export const LntButton = forwardRef<HTMLElement, LntButtonProps>(Component)
